import { useState } from "react";

export function ChipPicker({ options, value, onChange, testid, placeholder = "Search…" }) {
  const [q, setQ] = useState("");
  const toggle = (v) => onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);
  const list = options.filter((o) => !q || o.label.toLowerCase().includes(q.toLowerCase()));
  return (
    <div data-testid={testid} className="rounded-lg border border-zinc-200 p-2">
      {options.length > 8 && <input data-testid={`${testid}-search`} value={q} onChange={(e) => setQ(e.target.value)} placeholder={placeholder} className="mb-2 h-8 w-full rounded-md border px-2 text-xs outline-none" />}
      <div className="thin-scroll flex max-h-32 flex-wrap gap-1.5 overflow-y-auto">
        {list.map((o) => (
          <button type="button" key={o.value} data-testid={`${testid}-opt-${o.value}`} onClick={() => toggle(o.value)}
            className={`rounded-full border px-2.5 py-1 text-[11px] font-semibold transition-colors ${value.includes(o.value) ? "border-[#C5A46D] bg-[#C5A46D] text-[#171923]" : "border-zinc-200 text-zinc-600 hover:border-[#C5A46D]"}`}>
            {o.label}
          </button>
        ))}
      </div>
    </div>
  );
}
